/*
  Story 2.9 — trocar a cor NO PROPRIO CARD da PLP, sem ir para a PDP.
  Pedido do Paulo (29/08): "quando seleciona tenta selecionar outra cor, ao inves de
  mudar so para cor na tela atual, ele redireciona para pagina do produto direto."

  Progressive enhancement: cada bolinha JA e um <a href> real para o produto irmao.
  Este arquivo apenas intercepta o clique. Sem JS, ou se algo aqui falhar, o link
  continua funcionando como antes — nada quebra.

  Delegacao de evento no document: a PLP troca de conteudo em filtro/paginacao (o tema
  re-renderiza a secao), entao registrar por elemento perderia os cards novos.

  O que troca: foto (src + srcset + alt + a marca de foto horizontal), titulo, preco,
  preco riscado e TODOS os links do card. A marcacao de cor atual anda junto, sem
  reordenar a fileira (regra da 2.8).
*/
(function () {
  'use strict';

  var SW = '[data-cbs-swatches] a.cbs-swatch';

  // o titulo mora no aria-label (unica copia no HTML). O da bolinha atual traz
  // " (current)" no fim, que nao faz parte do nome do produto.
  function tituloDe(sw) {
    return (sw.getAttribute('aria-label') || '').replace(/\s*\(current\)$/, '');
  }

  function acharCard(el) {
    return el.closest('.card-wrapper') || el.closest('.grid__item') || null;
  }

  function trocarFoto(card, sw) {
    var img = card.querySelector('.card__media img');
    if (!img) return;
    var src = sw.getAttribute('data-cbs-img');
    if (!src) return;

    // o HTML carrega so a URL base; o srcset e montado aqui para nao inflar a pagina
    // (mandar as 4 URLs prontas por bolinha custava +20% no peso da PLP de calcado)
    var sep = src.indexOf('?') === -1 ? '?' : '&';
    img.setAttribute('src', src + sep + 'width=533');
    img.setAttribute('srcset', [360, 533, 720, 940].map(function (w) {
      return src + sep + 'width=' + w + ' ' + w + 'w';
    }).join(', '));
    img.setAttribute('alt', tituloDe(sw));

    // a caixa do card e 4:5; foto horizontal precisa da classe que troca cover->contain,
    // senao volta o corte de ~56% que a story 2.6 consertou
    var media = img.closest('.media');
    if (media) {
      if (sw.getAttribute('data-cbs-wide') === '1') {
        media.classList.add('cbs-media--wide');
      } else {
        media.classList.remove('cbs-media--wide');
      }
    }

    // a foto secundaria (a que aparece no hover) e do produto antigo: escondê-la evita
    // mostrar a cor errada quando o mouse passa
    var todas = card.querySelectorAll('.card__media img');
    for (var i = 1; i < todas.length; i++) {
      todas[i].style.display = 'none';
    }
  }

  function trocarTexto(card, sw) {
    var titulo = tituloDe(sw);
    var link = card.querySelector('.card__heading a');
    if (link && titulo) link.textContent = titulo;

    var url = sw.getAttribute('href');
    if (url) {
      var links = card.querySelectorAll('a.full-unstyled-link, .card__heading a');
      for (var i = 0; i < links.length; i++) {
        links[i].setAttribute('href', url);
      }
    }

    var preco = sw.getAttribute('data-cbs-price');
    if (preco) {
      var reg = card.querySelector('.price__regular .price-item--regular');
      if (reg) reg.textContent = preco;
      var sale = card.querySelector('.price__sale .price-item--sale');
      if (sale) sale.textContent = preco;
      if (!reg && !sale) {
        var qualquer = card.querySelector('.price-item--regular');
        if (qualquer) qualquer.textContent = preco;
      }
    }

    var comp = sw.getAttribute('data-cbs-compare');
    var bloco = card.querySelector('.price');
    if (bloco) {
      // o tema alterna .price--on-sale para mostrar ou ocultar o riscado
      if (comp) {
        bloco.classList.add('price--on-sale');
        var risc = card.querySelector('.price__sale s .price-item, .price-item--regular.price--end');
        if (risc) risc.textContent = comp;
      } else {
        bloco.classList.remove('price--on-sale');
      }
    }
  }

  function marcarAtual(fileira, sw) {
    var todas = fileira.querySelectorAll('a.cbs-swatch');
    for (var i = 0; i < todas.length; i++) {
      var a = todas[i];
      a.classList.remove('cbs-swatch--current');
      a.removeAttribute('aria-current');
      a.setAttribute('aria-label', tituloDe(a));
    }
    sw.classList.add('cbs-swatch--current');
    sw.setAttribute('aria-current', 'true');
    sw.setAttribute('aria-label', tituloDe(sw) + ' (current)');
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest ? e.target.closest(SW) : null;
    if (!sw) return;
    // o "+N" nao troca nada: leva para a PDP, onde o grupo completo aparece
    if (sw.classList.contains('cbs-swatch--more')) return;
    // sem dados embutidos, deixa o link agir como antes
    if (!sw.getAttribute('data-cbs-img') && !sw.getAttribute('data-cbs-price')) return;

    var card = acharCard(sw);
    var fileira = sw.closest('[data-cbs-swatches]');
    if (!card || !fileira) return;

    e.preventDefault();
    e.stopPropagation();

    trocarFoto(card, sw);
    trocarTexto(card, sw);
    marcarAtual(fileira, sw);
  });
})();
